import type * as React from "react";

import { cn } from "../lib/cn";

export type LabelTapeSize = "sm" | "lg";

const sizeClasses: Record<LabelTapeSize, string> = {
  sm: "px-2 py-1 text-[0.6875rem] tracking-[0.13em] shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.4)]",
  lg: "px-[13px] pt-[7px] pb-[6px] text-[0.8125rem] tracking-[0.18em] shadow-[0_1px_0_rgba(46,35,24,0.35)]",
};

export interface LabelTapeProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: LabelTapeSize;
  children: React.ReactNode;
  ref?: React.Ref<HTMLSpanElement>;
}

/** Names of physical things (rooms, machines) only; never a state or a button. */
export function LabelTape({
  size = "sm",
  children,
  className,
  ...rest
}: LabelTapeProps) {
  return (
    <span
      className={cn(
        "inline-block whitespace-nowrap rounded-[2px] bg-nav",
        "font-mono font-medium uppercase text-ink-on-nav",
        sizeClasses[size],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
